import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';

import { PrintService } from '../print/print.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';


@Component({
  selector: 'container',
  providers: [StorageService, PrintService],
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements AfterViewInit, OnInit {

  allContainers: any[] = [];
  containers: any[] = [];
  filteredContainers: any[];
  filterTitle: string;
  filterString: string = '';
  displayValueLineHaul: any[] = [];
  displayValueWeight: any[] = [];
  displayValueDepth: any[] = [];
  displayValueLength: any[] = [];
  displayValueHeight: any[] = [];
  displayValueRelabel: any[] = [];

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _printService: PrintService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('Container');
    //this.loadFilter('ALL', 'All parcels in storage');
    this.load();
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
    this.filterContainers(this.filterString);
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  filterContainers(value: string = ''): void { //load not deleted containers
    this.filterString = value;
    if(value!=""){
      this.filteredContainers = this.allContainers.filter((container: any) => {
          return (this.filterString == '') ||
                 (container.name.toLowerCase().indexOf(value.toLowerCase()) > -1     || 
                   container.containerStatus.toLowerCase().indexOf(value.toLowerCase()) > -1
                 );
      });
    }else{
      this.filteredContainers = this.containers
    }
  }


  async load(): Promise<void> {
    try {
      this._loadingService.register('container.list');
      await this.getContainers();
      this.allContainers = this.containers
      this.containers = this.containers
        .filter((container: any) => container.containerStatus.indexOf('DELETED') == -1)
        .reverse()
        .slice(0, 100); // only the first 100 elements
      this.loadFilter('All containers');    
    } catch (error) {

    } finally {
      this.filteredContainers = Object.assign([], this.containers);
      this._loadingService.resolve('container.list');
    }
  }

  async getContainers(): Promise<void> {
    this.containers = await this._storageService.getContainers('CONTAINER').toPromise();
  }

  deleteContainer(container: any): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want to delete the container?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._deleteContainer(container);
        }
      });
  }

  private async _deleteContainer(container: any): Promise<void> {
    try {
      this._loadingService.register('container.list');
      await this._storageService.deleteContainer(container).toPromise();
      this._snackBarService.open('Container deleted', 'Ok');
      this.load();
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to delete the container'});
    } finally {
      this._loadingService.resolve('container.list');
    }
  }

  printContainerLabel(container: any): void {
    this._dialogService
      .openConfirm({message: 'PRINT ' + container.name})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._printContainerLabel(container.name);
        }
      });
    
  }  

  private async _printContainerLabel(containerName: string): Promise<void> {
    try {
      this._loadingService.register('container.list');
      await this._storageService.getContainerLabel(containerName).toPromise();
      await this.sleep(1000);
      await this._printService.print('labelPrinter', containerName).toPromise();
      this._snackBarService.open('Print', 'OK');
      this.load();
    } catch (error) {
       this._dialogService.openAlert({message: 'There was an error trying to print the container'});
    } finally {
      this._loadingService.resolve('container.list');
    }
  }

  sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  displayCondition(addInfo: any[], index: number) {
    let keyValue: string = 'line_haul';
    this.displayValueLineHaul.push('')
    for(let element of addInfo) {
      if (element.keyValue.toLowerCase().indexOf(keyValue.toLowerCase()) > -1) {
        if (element.textValue) { this.displayValueLineHaul[index] = element.textValue;}
        else if (element.numericalValue) {this.displayValueLineHaul[index] = element.numericalValue;}
        break;
      }
    }
    
    keyValue = 'weight';
    this.displayValueWeight.push('');
    for(let element of addInfo) {
      if (element.keyValue.toLowerCase().indexOf(keyValue.toLowerCase()) > -1) {
        if (element.textValue) { this.displayValueWeight[index] = element.textValue;}
        else if (element.numericalValue) {this.displayValueWeight[index] = element.numericalValue;}
        break;
      }
    }
    
    keyValue = 'depth';
    this.displayValueDepth.push('');
    for(let element of addInfo) {
      if (element.keyValue.toLowerCase().indexOf(keyValue.toLowerCase()) > -1) {
        if (element.textValue) { this.displayValueDepth[index] = element.textValue;}
        else if (element.numericalValue) {this.displayValueDepth[index] = element.numericalValue;}
        break;
      }
    }
    
    keyValue = 'length';
    this.displayValueLength.push('');
    for(let element of addInfo) {
      if (element.keyValue.toLowerCase().indexOf(keyValue.toLowerCase()) > -1) {
        if (element.textValue) { this.displayValueLength[index] = element.textValue;}
        else if (element.numericalValue) {this.displayValueLength[index] = element.numericalValue;}
        break;
      }
    }
    
    keyValue = 'height';
    this.displayValueHeight.push('');
    for(let element of addInfo) {
      if (element.keyValue.toLowerCase().indexOf(keyValue.toLowerCase()) > -1) {
        if (element.textValue) { this.displayValueHeight[index] = element.textValue;}
        else if (element.numericalValue) {this.displayValueHeight[index] = element.numericalValue;}
        break;
      }
    }

    keyValue = 'relabel';
    this.displayValueRelabel.push('');
    for(let element of addInfo) {
      if (element.keyValue.toLowerCase().indexOf(keyValue.toLowerCase()) > -1) {
        if (element.textValue) { this.displayValueRelabel[index] = element.textValue;}
        else if (element.numericalValue) {this.displayValueRelabel[index] = element.numericalValue;}
        break;
      }
    }
    
    return true;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/container/container.component.ts